import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../../../Helpers/constants';
import KenButton from '../../../KenButton';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0px 16px',
    background: '#FFFFFF',
    paddingRight: '10vw',
    paddingLeft: '10vw',
    bottom: 0,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      margin: 12,
    },
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '0px 16px',
      'min-height': '60px',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      position: 'fixed',
      bottom: '0px',
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px 12px',
    },
  },
  previousBtn: {
    gap: '10px',
    width: '111px',
    'border-radius': '4px',
    border: 'none !important',
    'font-style': 'normal',
    'font-weight': '500 !important',
    'font-size': '16px !important',
    'line-height': '100% !important',
    display: 'flex',
    'text-align': 'center',
    color: '#604797 !important',
    backgroundColor: 'transparent !important',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      marginLeft: '16px',
    },
    [theme.breakpoints.down('md')]: {
      'border-radius': '8px',
      width: '100%',
      border: '1px solid #D1C8E3 !important',
    },
  },
  saveBtn: {
    gap: '10px',
    'border-radius': '4px',
    'font-style': 'normal',
    'font-weight': '500 !important',
    'font-size': '16px !important',
    'line-height': '100% !important',
    display: 'flex',
    'text-align': 'center',
    color: '#604797 !important',
    backgroundColor: 'transparent !important',
    padding: '8px',
    width: '160px',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: 80,
    },
  },
  nextBtn: {
    display: 'flex',
    padding: '8px',
    gap: '8px',
    width: '140px',
    backgroundColor: '#604797 !important',
    'border-radius': '8px !important',
    'font-style': 'normal',
    'font-weight': '500 !important',
    'font-size': '16px !important',
    'line-height': '100% !important',
    'text-align': 'center',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      marginRight: '16px',
      width: '100%',
    },
  },
}));

export default function KenStepperFooter(props) {
  const classes = useStyles();
  const theme = useTheme();
  const navigate=useNavigate()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onNext, onPrev, onSave, isSave = true, isPrev = true, isNext = true, activeStep, totalSteps, applicationStatus = 'Application Incomplete' } = props;

  return (
    <div
      className={classes.root}
      style={{
        width: '100%',
        display: applicationStatus === 'Application Incomplete' || applicationStatus === '' ? '' : 'none',
      }}
    >
      <Grid container width={'100%'} justifyContent={'space-between'} direction="row" borderTop={isMobileScreen ? 'none' : '1px solid #E6E6E6'} paddingTop={'20px'}>
        {!isMobileScreen && (
          <Grid item>
            {isSave && (
              <KenButton buttonClass={classes.saveBtn} variant="text" style={{ marginRight: 8 }} onClick={onSave} data-testid="btn-save">
                Save as draft
              </KenButton>
            )}
          </Grid>
        )}
        {isMobileScreen ? (
          <Box component={'div'} className="w-100 d-flex gap-1 align-items-center">
            {isPrev && (
              <KenButton
                buttonClass={classes.previousBtn}
                variant="outlined"
                onClick={onSave}
                fullWidth
                disabled={activeStep === 0 || applicationStatus === 'Application form Submitted'}
                style={{
                  marginRight: 8,
                  pointerEvents: 'auto',
                  cursor: activeStep === 0 || applicationStatus === 'Application form Submitted' ? 'not-allowed' : 'pointer',
                }}
                data-testid="btn-prev"
              >
                Save as draft
              </KenButton>
            )}
            {isNext && (
              <KenButton
                fullWidth
                buttonClass={classes.nextBtn}
                type="submit"
                form={`form-step${activeStep}`}
                variant="contained"
                onClick={onNext}
                disabled={applicationStatus === 'Application form Submitted'}
                data-testid="btn-next"
              >
                {activeStep === totalSteps - 1 ? 'Apply' : 'Next'}
              </KenButton>
            )}
          </Box>
        ) : (
          <Grid item>
            <Grid container justifyContent="flex-end">
              <Grid item>
                {isPrev && (
                  <KenButton
                    buttonClass={classes.previousBtn}
                    variant="outlined"
                    onClick={() => {
                      if (activeStep === 0) {
                        navigate(-1);
                      } else {
                        onPrev();
                      }
                    }}
                    fullwidth
                    disabled={applicationStatus === 'Application form Submitted'}
                    style={{
                      marginRight: 8,
                      pointerEvents: 'auto',
                      cursor: applicationStatus === 'Application form Submitted' ? 'not-allowed' : 'pointer',
                    }}
                    data-testid="btn-prev"
                  >
                    Back
                  </KenButton>
                )}
              </Grid>
              <Grid item>
                {isNext && (
                  <KenButton
                    fullwidth
                    buttonClass={classes.nextBtn}
                    type="submit"
                    form={`form-step${activeStep}`}
                    variant="contained"
                    onClick={onNext}
                    disabled={applicationStatus === 'Application form Submitted'}
                    data-testid="btn-next"
                  >
                    {activeStep === totalSteps - 1 ? 'Apply' : 'Next'}
                  </KenButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
